module.exports = __webpack_public_path__ + "img/failed.fab9bb04.svg";